import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Vaanmathi/Header/header";
import Footer from "./Vaanmathi/Footer/footer";
import LandingPage from "./Vaanmathi/LandingPage/Main";
import AboutUs from "./Vaanmathi/AboutUs/aboutus";
import ServicesPage from "./Vaanmathi/Services/servicespage";
import ProductPagedetail from "./Vaanmathi/Products/productpage";
import MainPortfilio from "./Vaanmathi/PortfolioPage/MainPortfilio";
import Contact from "./Vaanmathi/GetinTouchform/GetinTouch";
import TechBlogPage from "./Vaanmathi/Blog/blog";
import ThankYouPage from "./Vaanmathi/GetinTouchform/thankyou";
import ServiceDetails from "./Vaanmathi/Services/servicesdetail";
import ProductFullDetailsView from "./Vaanmathi/Products/productfulldetails";
import ContactUs from "./Vaanmathi/GetinTouchform/contactus";
import BlogDetails from "./Vaanmathi/Blog/blogdetail";
import Privacypolicy from "./Vaanmathi/SiteConfig/privacypolicy";
import Terms from "./Vaanmathi/SiteConfig/terms";
import FloatingButtons from "./Vaanmathi/Floatingicons/Floatingicons";
import ThemeListener from "./Vaanmathi/ColorConfig/themelistener";
import { fetchTheme } from "./Vaanmathi/ColorConfig/themeservice";
import GetInTouchForm from "./Vaanmathi/GetinTouchform/GetinTouch";
import OurProjects from "./Vaanmathi/OurProjects/OurProjects";

function App() {
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const [hasShownModal, setHasShownModal] = useState(false);

  useEffect(() => {
    // Fetch theme on app load
    fetchTheme();

    // Check if we've already shown the modal in this session
    const modalShown = sessionStorage.getItem("getInTouchModalShown");

    if (!modalShown) {
      // Show modal after 9 seconds for first-time visitors
      const timer = setTimeout(() => {
        setShowGetInTouch(true);
        sessionStorage.setItem("getInTouchModalShown", "true");
        setHasShownModal(true);
      }, 12000);

      return () => clearTimeout(timer);
    } else {
      setHasShownModal(true);
    }
  }, []);

  const closeGetInTouch = () => {
    setShowGetInTouch(false);
  };

  // Show modal on page refresh/reload after 3 seconds
  useEffect(() => {
    const handleBeforeUnload = () => {
      // Clear the session storage when user refreshes the page
      sessionStorage.removeItem("getInTouchModalShown");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

 

  return (
    <ThemeListener>
      <Router>
        <div className="App w-full overflow-x-hidden min-h-screen">
          <Header />
          <main className="w-full overflow-x-hidden">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/servicedetails/:id" element={<ServiceDetails />} />
              <Route path="/products" element={<ProductPagedetail />} />
              <Route
                path="/productdetails/:id"
                element={<ProductFullDetailsView />}
              />
              <Route path="/portfolio" element={<MainPortfilio />} />
              <Route path="/blog" element={<TechBlogPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/thankyou" element={<ThankYouPage />} />
              <Route path="/contactus" element={<ContactUs />} />
              <Route path="/blogdetail" element={<BlogDetails />} />
              <Route path="/privacypolicy" element={<Privacypolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/OurProjects" element={<OurProjects/>}/>
            </Routes>
          </main>
          <Footer />
          <FloatingButtons />

          {/* GetInTouch Modal */}
          {showGetInTouch && (
            <div className="modal-overlay" onClick={closeGetInTouch}>
              <div
                className="modal-content-custom"
                onClick={(e) => e.stopPropagation()}
              >
                <button className="close-button" onClick={closeGetInTouch}>
                  &times;
                </button>
                <GetInTouchForm isModal={true} onSuccess={closeGetInTouch} />
              </div>
            </div>
          )}
        </div>
      </Router>
    </ThemeListener>
  );
}

export default App;
